import styled, { css } from 'styled-components';

import {
    floorGameColor as color,
    CommonAction,
    designColor,
    recipesCommonAction,
    styledInteraction,
    styledMedia,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './Actions.tokens';

const buttonExtension = css`
    gap: ${tokens.action.gap}px;
    padding: 0 ${tokens.action.height.mobile / 2}px;
    width: 100%;
    height: ${tokens.action.height.mobile}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0 ${tokens.action.height.desktop / 2}px;
        height: ${tokens.action.height.desktop}px;
    }

    &[aria-pressed] {
        ${styledInteraction.interactionDisable};
    }

    &:disabled {
        opacity: 0.8;
    }
`;

export const StyledActions = styled.ul`
    ${styledReset.list};
    display: grid;
    gap: ${tokens.list.gap}px;
    grid-auto-flow: column;
    flex: 1 0 auto;
`;

export const Item = styled.li``;

export const AcceptAction = styled(CommonAction)`
    ${recipesCommonAction.primaryGradient};
    ${buttonExtension};
    background-color: ${color.forest};

    &[aria-pressed]::before {
        opacity: 0;
    }
`;

export const RejectAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    ${buttonExtension};
    background-color: rgb(255, 255, 255, 0.06);
    border: 1px solid rgb(255, 255, 255, 0.1);

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.1);
    }

    &[aria-pressed] {
        background-color: rgb(255, 0, 76, 0.1);
        border-color: ${designColor.red};
    }
`;

export const Label = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    z-index: 3;
    position: relative;
    font-size: ${tokens.label.size.mobile}px;
    font-weight: 600;
    letter-spacing: -0.02em;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${tokens.label.size.desktop}px;
        font-weight: 700;
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    z-index: 4;
    position: relative;
    width: ${tokens.icon.size}px;
    height: ${tokens.icon.size}px;
`;
